import React from "react";
import { StatsWidgetLoaderTemplate } from "themes/administration/analytics/components";

function StatsWidgetLoader(props) {
    return <StatsWidgetLoaderTemplate {...props} />;
}

export default StatsWidgetLoader;
